import { SET_ERROR_MESSAGE } from '../utils/constants'

export const setErrorMessage = (payload) => ({ type: SET_ERROR_MESSAGE, payload })